export enum GoalLevel {
  ACCOUNT = "ACCOUNT",
  BUYSPACE = "BUYSPACE",
  SUPPLIER = "SUPPLIER"
}
